<ng-container>
    <h4 mat-dialog-title
        >{{ translate.get(tabName) }}
        <span i18n="@@efac3af0b32e953279c25b6519cae256811e0fe8" t="efac3af0b32e953279c25b6519cae256811e0fe8"
            >History</span
        ></h4
    >
    <div class="grid" style="overflow-y:auto">
        <div #AuditGrid id="AuditGrid" style="width:100%;min-height:200px" class="ag-theme-balham"></div>
    </div>
</ng-container>
